import { initWeekWorkingDays } from '@/constants';
import {
  CountdownMethodEnum,
  CountdownTimerOption,
  DataCalculationMethodEnum,
  DateDisplayMode,
  DateRangeDirection,
  DateRangeIcon,
  DeliveryMethodLayout,
  EnableApp,
  EnableTimelineLayout,
  EndBehaviorEnum,
  Plan,
  RenderMethod,
  Rules,
  SessionBehaviorEnum,
  SortOptionsEnum,
  Subscription,
  TimeCountDownFormat,
} from '@/constants/enum';
import { END_DATE_MARKER, START_DATE_MARKER } from '@/constants/string';
import { IParamsApi } from '@/types/apis/params';
import { IResponseApi } from '@/types/apis/response';

export const InitShopInfo: IResponseApi.IShopInfo['data'] = {
  country: '',
  email: '',
  lastInstalledDate: '',
  shop: '',
  shopName: '',
  shopifyPlan: '',
  shopId: '',
  appId: '',
};

export const InitZipcodeSettings: IParamsApi.IZipcodeSetting = {
  id: 0,
  shop: '',
  inputLabel: 'Check Shipping Availability',
  inputPlaceholder: 'Enter zipcode text',
  submitButton: 'Submit',
  submitButtonBackgroundColor: '#2c3e50',
  submitButtonTextColor: '#2D77E4',
  zipcodeAvailableText: 'Shipping available at',
  zipcodeNotAvailableText: 'Shipping unavailable at',
};

interface IDataSettingState extends IParamsApi.IUpdateGeneralSetting {
  id: number;
}
export const InitDataSettings: IDataSettingState = {
  id: 0,
  shop: '',
  script_tag_id: '',
  layout: Rules.PostCode,
  week_working_days: initWeekWorkingDays,
  isUseSeparateWorkingDays: false,
  specific_day_off: [],
  position_code: 2,
  date_format: 'MM/DD/YYYY',
  text_size: 12,
  text_color: '#000000',
  icon_color: '#1373DC',
  custom_css: '',
  show_on_line_item: 0,
  show_on_pages: 'products,collections',
  custom_position: '',
  render_method: RenderMethod.Prepend,
  estimated_icon: '<i class="fa fa-check"></i>',
  enable_app: EnableApp.Active,
  date_locale: 'en',
  date_display_mode: DateDisplayMode.Absolute,
  date_timezone_offset: '',
  get_user_info: 1,
  disable_when_product_is_out_of_stock: 1,
  type_time_countdown: TimeCountDownFormat.Full,
  countdown_timer_option: CountdownTimerOption.NextCutoff,
  countdown_timer_show_after_cutoff: true,
  days: 'day(s)',
  hours: 'hour(s)',
  minutes: 'minute(s)',
  seconds: 'second(s)',
  require_add_to_cart: 0,
  border_color: '#FFFFFF',
  background_color: '#FFFFFF',
  choose_layout: DeliveryMethodLayout.Card,
  labelCheckout: 'Estimated between',
  get_customer_zipcode: 1,
  enable_timeline_layout: EnableTimelineLayout.Active,
  enable_eta_information: true,
  timeline_order_step_title: 'Ordered',
  timeline_ship_step_title: 'Shipped',
  timeline_delivery_step_title: 'Delivered',
  timeline_order_step_description: '',
  timeline_ship_step_description: '',
  timeline_delivery_step_description: '',
  timeline_ship_step_enable: true,
  timeline_order_step_enable: true,
  timeline_delivery_step_enable: true,
  should_show_survey: 1,
  confirmationUrl: '',
  displayOnboarding: false,
  enableDebugger: 0,
  jquery_version: '',
  plan: Plan.FREE,
  planUpdatedAt: 0,
  showNameMethodInProperties: 0,
  subscription: Subscription.Monthly,
  show_shipping_method: true,
  cart_page_label_text: 'Estimated between',
  cart_page_date_display: `${START_DATE_MARKER} and ${END_DATE_MARKER}`,
  timeline_date_range_direction: DateRangeDirection.Vertical,
  timeline_date_range_icon: DateRangeIcon.Arrow,
  timelineShipIcon: {
    iconUrl: '',
    isCustom: false,
    iconId: 45,
  },
  timelineOrderIcon: {
    iconUrl: '',
    isCustom: false,
    iconId: 0,
  },
  timelineDeliveryIcon: {
    iconUrl: '',
    isCustom: false,
    iconId: 68,
  },
  isShowDeliveryMethodName: true,
  themeStoreId: -1,
  themeName: '',
  zipcodeSetting: InitZipcodeSettings,
  isDynamicDateInCart: false,
  customDynamicDateInCart: '',
  detectionMethod: IParamsApi.DetectionMethod.ShopLocale,
  shippingMethodLabel: 'Shipping method',
  ruleSortBy: SortOptionsEnum.IdDesc,
  dateCalculationMethod: DataCalculationMethodEnum.OrderDate,
  countdownMethod: CountdownMethodEnum.UntilCutoff,
  durationInSeconds: 23 * 60 * 60 + 59 * 60 + 59,
  sessionBehavior: SessionBehaviorEnum.RestartEachSession,
  endBehavior: EndBehaviorEnum.Hide,
};
